<template>
	<v-list nav density="compact" class="nav-menu-list" bg-color="transparent">
		<v-list-item v-for="item in menu.primary" :key="item.key" :active="item.view === activeView" :title="t(item.labelKey)" rounded="lg" class="nav-menu-list__item" @click="emit('select', item)">
			<template #prepend>
				<v-icon>{{ item.icon }}</v-icon>
			</template>
		</v-list-item>

		<template v-for="group in menu.groups" :key="group.key">
			<v-list-subheader class="nav-menu-list__title">{{ t(group.titleKey) }}</v-list-subheader>
			<v-list-item v-for="item in group.items" :key="item.key" :active="!item.shortcut && item.view === activeView" :title="t(item.labelKey)" rounded="lg" class="nav-menu-list__item" @click="emit('select', item)">
				<template #prepend>
					<v-badge v-if="item.shortcut && item.count" :content="item.count" color="secondary" floating>
						<v-icon>{{ item.icon }}</v-icon>
					</v-badge>
					<v-icon v-else>{{ item.icon }}</v-icon>
				</template>
			</v-list-item>
		</template>
	</v-list>
</template>

<script setup>
import { useTranslator } from '@/composables/useTranslator';

defineProps({
	menu: { type: Object, required: true },
	activeView: { type: String, default: null },
});
const emit = defineEmits(['select']);

const t = useTranslator();
</script>
